"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.auditLogFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const authored_evidence_1 = require("../../composite/evidence/authored-evidence/authored-evidence");
const evidence_1 = require("../../composite/evidence/evidence");
const alog_fields_1 = require("./alog-fields");
const alog_columns_1 = require("./alog-columns");
function auditLogFactory({ url, reportTag, }) {
    return function Auditlog() {
        const intl = react_intl_1.useIntl();
        const evidence = authored_evidence_1.useAuthoredEvidence({
            identifier: 'ALOG',
            apiProps: {
                url,
            },
            tableProps: {
                columns: alog_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'EAS_ALOG_TABLE_TITLE',
                    defaultMessage: 'Auditní log',
                }),
                reportTag,
            },
            detailProps: {
                toolbarProps: {
                    showButton: lodash_1.stubFalse,
                },
                FieldsComponent: alog_fields_1.AlogFields,
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.auditLogFactory = auditLogFactory;
auditLogFactory.useColumns = alog_columns_1.useColumns;
auditLogFactory.Fields = alog_fields_1.AlogFields;
//# sourceMappingURL=alog.js.map